
let container = document.getElementById('webien-object-map');
if(container){

    // listen for click on "object-map" id and initioalize after click
    let initialized = false;
    jQuery('summary').on('click', function () {
        let el = jQuery(this);
        if(el.closest('details').find(".map-accordion") && !initialized){
            initializeMap();
            initialized = true;
        }
    });
}


function initializeMap() {

    mapboxgl.accessToken = 'pk.eyJ1IjoibWlrYWVsYmV2ZW50b3JwIiwiYSI6ImNtaG5qenN4bjAxZDIycXF2ZWVkOGZ1eDEifQ.VgxwaYJ9lbfYzsPIOBS_7Q';


    const map = new mapboxgl.Map({
        container: 'webien-object-map', // ID på elementet där kartan ska visas
        //style: 'mapbox://styles/mapbox/streets-v11', // Kartstil
        center: [window.objectLng, window.objectLat], // Startposition [longitude, latitude]
        zoom: 17, // Startzoom
        pitch: 30, // Lutning i grader
    });

    // Add zoom and rotation controls to the map.
    map.addControl(new mapboxgl.NavigationControl());


    const el = document.createElement('div');
    el.className = 'mam-marker';
    el.innerHTML = `<div class="inner"><img src="https://mamhomes.se/wp-content/uploads/2023/12/favicon-green-150x150.png"></div>`;
    // Pass the div.marker to the Marker instance
    new mapboxgl.Marker(el).setLngLat([window.objectLng, window.objectLat]).addTo(map);


    // Trigger resize event after a short delay to ensure the map is rendered correctly
    setTimeout(() => {
        map.resize();
    }, 500);
}

